import $ from '../common/js/jquery3.4.1'
import Swiper from '../common/js/swiper.4.5'

export function SwiperController(){

    var objSwiper;
    var objSwiper2;

    function validaPaginador() {

        //swiper-button-disabled
        var final = objSwiper.slides.length;
        var slideActual = objSwiper.realIndex + 1;
        if (slideActual > 1 && slideActual < final) {
            $(".swiper-button-prev").removeClass("swiper-button-disabled");
            $(".swiper-button-next").removeClass("swiper-button-disabled");
        }
    }
 
    function setPAginationBreadcrumbOneSlide() {
        var text="";
        $("#text_pagination").html("");
        $(".swiper-button-prev").addClass("swiper-button-disabled");
        $(".swiper-button-next").addClass("swiper-button-disabled");
        text = "Página 1 de 1";
        var datatittle = document.getElementsByClassName("swiper-slide")[0].getAttribute("data-title");
        $("#text_pagination").append(text);
        $(".breadcrumb").text(datatittle);
    }
    $(function () {
        //localStorage.clear();
    
        // Vista Dinamica Tema 1: Slide 9
        $(".overimg").click(function () {
            var btn = $(".overimg");
            btn.removeClass("btn-activado");
            $(this).addClass("btn-activado");
        });
    
        $("#text_pagination").html("");
        //initialize swiper when document ready
        var mySwiper = new Swiper(".swiper-container", {
            // Optional parameters
            direction: "horizontal",
            initialSlide: 0,
            speed: 400,
            loop: false,
            spaceBetween: 100,
            setWrapperSize: true,
            paginationType: "progress",
            roundLengths: false,
            preloadImages: true,
            updateOnImagesReady: true,
            preventClicks: true,
            noSwiping: true,
            noSwipingClass: "swiper-no-swiping",
            navigation: {
                nextEl: ".icon-siguiente",
                prevEl: ".icon-atras"
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });

        objSwiper = mySwiper;
        mySwiper.keyboard.enable();

        var mySwiper2 = new Swiper(".swiper-container-2", {
            direction: "horizontal",
            initialSlide: 0,
            noSwiping: true,
            noSwipingClass: "swiper-no-swiping",
            speed: 1000,
            spaceBetween: 0,
            setWrapperSize: true,
            paginationType: "progress",
            roundLengths: false,
            preloadImages: true,
            updateOnImagesReady: true,
    
            navigation: {
                nextEl: ".btn_siguiente",
                prevEl: ".btn_atras"
            },
    
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    
        objSwiper2=mySwiper2;
    
        //tomamos todos los swiper slide
        var swiperSlides = $(".swiper-slide");
        var idx = parseInt(mySwiper.realIndex) + 1;
        var text = "Página " + idx + " de " + mySwiper.slides.length;
        $("#text_pagination").append(text);
    
        //seteamos el valor en el breadcrum
        var titleSlide1 = $(swiperSlides[0]).attr("data-title");
        $(".breadcrumb").append($(swiperSlides[0]).attr("data-title"));
    
        mySwiper.on("slideChange", function () {
    
            var slideActual = mySwiper.realIndex + 1;
    
            var slideDOM = $("#slide-" + slideActual);
    
            var elementosAnimados = $(slideDOM).find(".animado");
    
            var numElementos = elementosAnimados.length;
    
            if (numElementos != 0) {
                for (var i = 0; i < elementosAnimados.length; i++) {
                    if ($(elementosAnimados[i]).hasClass("animado-Arr")) {
                        $(elementosAnimados[i]).addClass("fadeInUp");
                        $(elementosAnimados[i]).addClass("animated");
                    } else if ($(elementosAnimados[i]).hasClass("animado-Ab")) {
                        $(elementosAnimados[i]).addClass("fadeInDown");
                        $(elementosAnimados[i]).addClass("animated");
                    } else if ($(elementosAnimados[i]).hasClass("animado-Iz")) {
                        $(elementosAnimados[i]).addClass("fadeInLeft");
                        $(elementosAnimados[i]).addClass("animated");
                    } else if ($(elementosAnimados[i]).hasClass("animado-Der")) {
                        $(elementosAnimados[i]).addClass("fadeInRight");
                        $(elementosAnimados[i]).addClass("animated");
                    }
                }
            } else {
                var elementosAnim = $(".animado");
                for (var i = 0; i < elementosAnim.length; i++) {
                    if ($(elementosAnim[i]).hasClass("animado-Arr")) {
                        $(elementosAnim[i]).removeClass("fadeInUp");
                        $(elementosAnim[i]).removeClass("animated");
                    } else if ($(elementosAnim[i]).hasClass("animado-Ab")) {
                        $(elementosAnim[i]).removeClass("fadeInDown");
                        $(elementosAnim[i]).removeClass("animated");
                    } else if ($(elementosAnim[i]).hasClass("animado-Iz")) {
                        $(elementosAnim[i]).removeClass("fadeInLeft");
                        $(elementosAnim[i]).removeClass("animated");
                    } else if ($(elementosAnim[i]).hasClass("animado-Der")) {
                        $(elementosAnim[i]).removeClass("fadeInRight");
                        $(elementosAnim[i]).removeClass("animated");
                    }
                }
            }
    
            validaPaginador();
    
            $("#text_pagination").html("");
            idx = mySwiper.realIndex + 1;
            text = "Página " + idx + " de " + mySwiper.slides.length;
            $("#text_pagination").append(text);
            var $breadCrump = $(".breadcrumb");
            var count = [];
            var titleStr = [];
            var idx = parseInt(mySwiper.realIndex);
    
            for (var i = 0; i < mySwiper.realIndex + 1; i++) {
                if ($(swiperSlides[i]).attr("data-title")) {
                    var $hashItem = $("<li>");
    
                    if (i == 0) {
                        var _title = $(swiperSlides[i]).attr("data-title");
                    } else {
                        var _title = " &nbsp;/ " + $(swiperSlides[i]).attr("data-title");
                    }
                    var _a = $("<a>", { html: _title, href: "#" });
                    $hashItem.append(_a);
                    titleStr.push($hashItem);
                    count.push(i);
                }
            }
            $breadCrump.html(titleStr);
            $(".breadcrumb li:last-child")
                .find("a")
                .contents()
                .unwrap();
            $.each(titleStr, function (i, e) {
                $(e).click(function () {
                    mySwiper.slideTo(count[i]);
                });
            });
        });
    });
}